import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from "./ourteam.module.scss";
import useTranslation from "next-translate/useTranslation";

var Index = function Index() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsx("h2", {
      className: styles.header,
      children: t('aboutUs:our-team')
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.description,
      children: [/*#__PURE__*/_jsx("p", {
        children: t('aboutUs:wow-kanoon-bio')
      }), /*#__PURE__*/_jsxs("p", {
        className: styles.ParastooGhalamchi,
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.Name,
          children: t('aboutUs:parastoo-ghalamchi')
        }), /*#__PURE__*/_jsx("br", {}), t('aboutUs:ceo-founder'), /*#__PURE__*/_jsx("br", {}), t('aboutUs:ms-ghalamchi-bio'), /*#__PURE__*/_jsx("a", {
          href: "http://en.kanoon.ir/VideoClips.aspx?id=7",
          target: "_blank",
          children: t('aboutUs:saraye-danesh-school')
        }), ")."]
      }), /*#__PURE__*/_jsxs("p", {
        className: "pb-3",
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.Name,
          children: t('aboutUs:ashkan-pourbijan')
        }), /*#__PURE__*/_jsx("br", {}), t('aboutUs:ux-ui-designger'), /*#__PURE__*/_jsx("br", {}), t('aboutUs:project-manager')]
      }), /*#__PURE__*/_jsxs("p", {
        className: "pb-3",
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.Name,
          children: t('aboutUs:masoome-panahi')
        }), /*#__PURE__*/_jsx("br", {}), t('aboutUs:android-developer'), /*#__PURE__*/_jsx("br", {}), t('aboutUs:backend-developer')]
      }), /*#__PURE__*/_jsxs("p", {
        className: "pb-3",
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.Name,
          children: t('aboutUs:leila-khodaverdian')
        }), /*#__PURE__*/_jsx("br", {}), t('aboutUs:content-developer')]
      }), /*#__PURE__*/_jsxs("p", {
        className: "pb-3",
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.Name,
          children: t('aboutUs:raha-omrani')
        }), /*#__PURE__*/_jsx("br", {}), t('aboutUs:wp-developer')]
      }), /*#__PURE__*/_jsxs("p", {
        className: "pb-3",
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.Name,
          children: t('aboutUs:ali-najdi')
        }), /*#__PURE__*/_jsx("br", {}), t('aboutUs:frontend-developer')]
      }), /*#__PURE__*/_jsxs("p", {
        className: "pb-3",
        children: [/*#__PURE__*/_jsx("span", {
          className: styles.Name,
          children: t('aboutUs:shahrbanoo-aghaee')
        }), /*#__PURE__*/_jsx("br", {}), t('aboutUs:frontend-developer')]
      })]
    })]
  });
};

export default Index;